import React, { useState, useEffect, useContext} from "react";
import "./experience.scss";
import { ReactComponent as ArrowDown} from '../../Assets/Svg/arrowDown.svg';
import LanguageContext from "../../Contexts/Language";
type ExperienceProps = {
    scrollTop: number,
    height:  number
}

const Experience = (props: ExperienceProps) =>{
    const {language} = useContext(LanguageContext);
    const [isVisible, setIsVisible] = useState<Boolean>(false);
    const [isExpanded, setIsExpanded] = useState<Boolean>(false)
    const [canChange, setCanChange] = useState(true);
    
    useEffect(() =>{
      if(canChange){
        setIsVisible((props.scrollTop / (6092 / (window.outerWidth / window.innerWidth))) > 2600 / 6092);
        if((props.scrollTop / (6092 / (window.outerWidth / window.innerWidth))) > 2600 / 6092){
            setCanChange(false);
            setTimeout(() =>{
            setCanChange(true);
            },2750)
        }
      }
      else{
        if((props.scrollTop / (6092 / (window.outerWidth / window.innerWidth))) < 2600 / 6092){
            setIsVisible(false)
        }
      }
    },[props.scrollTop])


    useEffect(() =>{
        if(isVisible){
            setTimeout(() =>{
                setIsExpanded(isVisible)
            },1350)
        }
        else{
            setIsExpanded(false)
        }
    },[isVisible])

    const variableStyles = {
        "--transform-past": language.experience.transformPast,
        "height": `${props.height + 1}px`,
    } as React.CSSProperties;

    return(
        <div className={`experience-container experience-container-is-visible-${isVisible}`} style={variableStyles}>
            <div className="experience-header">{language.experience.title}</div>
            <div className="experience-wrapper">
                <div className="experience">
                    <div className={`line line-is-expanded-${isExpanded}`}>
                        <div className="time future">{language.experience.future}</div>
                        {
                            language.experience.jobs.map((job,key) =>(
                                <div className={`job is-left-${key % 2 === 1}`} key={key} style={{zIndex: `${100 - key}`}}>
                                    <div className="job-logo" style={{background: job.color}}>
                                        <img src={job.img} alt="Reliefy"/>
                                    </div>
                                    <div className={`job-inner blur-background`}>
                                        <div className="job-header">
                                            <div className="job-name">
                                                {job.name}
                                            </div>
                                            <div className="job-data">
                                                {job.date}
                                            </div>
                                        </div>
                                        <div className="job-type">
                                            {job.position}
                                        </div>
                                        <div className="job-description">{job.information.split("●").map((text,key) =>(key > 0 ? <li key={key}>{text}</li> : text))}</div>
                                    </div>
                                    <div className="cursor">
                                        <ArrowDown/>
                                    </div>
                                </div>
                            ))
                        }
                        <div className="time past">{language.experience.past}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Experience